
import { Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import { InputType } from '@/enums/InputType';
import { Permission } from '@/enums/Permission';
import VFormBuilder from '@/components/shared/form/VFormBuilder.vue';
import StackedForm from '@/mixins/StackedForm';
import { mixins } from 'vue-class-component';

@Component({
  components: { VFormBuilder },
})
export default class SanifairForm extends mixins(StackedForm) {
  public $refs!: {
    form: InstanceType<typeof VFormBuilder> & { form: any };
  };

  get initVals() {
    return (this.initialValues as any) || {};
  }

  get items() {
    return [
      { name: 'sanifairEnabled', type: InputType.Checkbox, label: 'venue.form.sanifairEnabled', default: false },
      { name: 'sanifairLocationId', type: InputType.Text, label: 'venue.form.sanifairLocationId' },
      { name: 'sanifairDeviceId', type: InputType.Text, label: 'venue.form.sanifairDeviceId' },
      {
        name: 'sanifairBingoEnabled',
        type: InputType.Checkbox,
        label: 'venue.form.sanifairBingoEnabled',
        default: false,
        visible: (form: any) => form.sanifairLocationId && this.$can(Permission.TABLE_SANIFAIR_COUNTER_VIEW),
      },
    ];
  }
}
